import angular from 'angular';

export default angular.module('cms.panels.summary', [])
    .component('summaryDemo', {
        template: require('./template.html')
    }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Dashboard/summaryDemoPanels/summaryDemo.js